module.exports = __webpack_public_path__ + "img/phone.0e4e3c2.svg";